import { Box, Container, Typography, Paper, Grid, Avatar } from '@mui/material';
import { motion } from 'framer-motion';

const Introduction = () => {
  return (
    <Box sx={{ py: 8, bgcolor: 'background.paper' }}>
      <Container maxWidth="md">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <Grid container spacing={4} alignItems="center">
            <Grid item xs={12} md={4}>
              <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <motion.div
                  initial={{ scale: 0.8, opacity: 0 }}
                  whileInView={{ scale: 1, opacity: 1 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5 }}
                >
                  <Avatar
                    src="/images/GrowYourBusinessCoFounder.svg"
                    // src="/images/profile.jpg"
                    alt="Tax Expert"
                    sx={{
                      width: 240,
                      height: 240,
                      border: 3,
                      borderColor: 'primary.main',
                      boxShadow: 3,
                    }}
                  />
                </motion.div>
              </Box>
            </Grid>
            <Grid item xs={12} md={8}>
              <Paper elevation={0} sx={{ p: 4, bgcolor: 'transparent' }}>
                <Typography variant="h4" component="h2" gutterBottom color="primary">
                  Meet the Founder
                </Typography>
                <Typography variant="body1" paragraph>
                  Hi, I'm Sally, and I've spent over <strong>10 years helping families and businesses</strong> with tax preparation, bookkeeping, payroll, and sales tax filings. During this time, I've helped hundreds of clients save money and grow their businesses. I've also spent <strong>4 years working at Intuit</strong>, where I served as a <strong>tax expert</strong>, managing and coaching tax professionals, and helping small businesses navigate complex tax issues.
                </Typography>
                <Typography variant="body1" paragraph>
                  I know what it takes to succeed in this industry, and I want to help you build your own thriving tax preparation business. While my program is ideal for those who already have a <strong>basic understanding of tax preparation</strong>, I'll guide you through the practical steps to get your business up and running quickly—without making the same mistakes I did.
                </Typography>
                <Typography variant="body1">
                  Whether you're just starting or looking to grow, my hands-on coaching and tools will give you the roadmap to succeed.
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </motion.div>
      </Container>
    </Box>
  );
};

export default Introduction;
